<template>
    <div>
        <ReceitaForm
            :form="form"
            :model="model"
            :is-pendente="isPendente"
            @save="handleSave()"
            @registrarNaoAtendido="$emit('registrarNaoAtendido', $event)"
            ref="ReceitaForm"
        />
    </div>
</template>

<script>
// Components
import ReceitaForm from '@/components/farmacia/components/receita/Form'

export default {
    components: { ReceitaForm },
    methods: {
        validate() {

            return this.$refs.Receita.validate()
        },
        save() {

            this.$refs.ReceitaForm.save()
        },
        handleSave() {

            this.$emit('save')
        },
        editItem(item) {

            this.$refs.ReceitaForm.editItem(item)
        },
        openModalSolicitacoes() {

            this.$refs.ReceitaForm.openModalSolicitacoes()
        }
    },
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
        isPendente: { type: Boolean, default: false },
        disabled: {type: Boolean, default: false}
    }
}
</script>